// @ts-strict-ignore
import Image from 'next/image'
import Link from 'next/link'
import { FC } from 'react'

import { AddAccessoryButton } from '@/features/cart/add-accessory'

import { TAccessory } from '@/entities/card/types/types'

import { BASE_URL } from '@/shared/lib/const/env'
import { formatPrice } from '@/shared/lib/utils/price/format-price'

import cl from './accessories-item.module.scss'

export const AccessoriesItem: FC<TAccessory & { relId: number }> = ({
	PRICES,
	SECTION_ID,
	KOD,
	IMAGE,
	TITLE,
	ID,
	relId
}) => {
	return (
		<div className={cl.card}>
			<Link prefetch={false} href={`/products/productID${KOD}/`} target={'_blank'}>
				<Image
					src={`${BASE_URL}${IMAGE}`}
					width={52}
					height={52}
					className={cl.img}
					alt={TITLE}
					style={{ objectPosition: 'top', objectFit: 'contain' }}
				/>
			</Link>
			<div className={cl.textWrapper}>
				<Link prefetch={false} href={`/products/productID${KOD}/`} target={'_blank'}>
					<h4 className={cl.title}>{TITLE}</h4>
				</Link>
				<p className={cl.price}>{formatPrice(PRICES.PRICE.VALUE)}</p>
			</div>
			<button className={cl.btn}>
				<AddAccessoryButton
					sectionID={SECTION_ID}
					productData={{ ID, KOD: KOD.toString(), IMAGE, TITLE, PRICE: PRICES.PRICE, relId: relId, SECTIONS: null }}
				/>
			</button>
		</div>
	)
}
